export const OPTION_ALERT_LIST_ATTEMPT = 'OPTION_ALERT_LIST_ATTEMPT';
export const OPTION_ALERT_LIST_SUCCESS = 'OPTION_ALERT_LIST_SUCCESS';
export const OPTION_ALERT_LIST_FAILED = 'OPTION_ALERT_LIST_FAILED';
export const OPTION_ALERT_NEW_SUCCESS = 'OPTION_ALERT_NEW_SUCCESS';
export const OPTION_ALERT_NEW_FAILED = 'OPTION_ALERT_NEW_FAILED';
export const OPTION_ALERT_REMOVE_SUCCESS = 'OPTION_ALERT_REMOVE_SUCCESS';
export const OPTION_ALERT_REMOVE_FAILED = 'OPTION_ALERT_REMOVE_FAILED';
